import { render } from "./IconArrowLeft.vue?vue&type=template&id=1d992bea&ts=true"
import script from "./IconArrowLeft.vue?vue&type=script&lang=ts"
export * from "./IconArrowLeft.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__